import { render } from "./ArchitectesInterieur.vue?vue&type=template&id=387b7e46&scoped=true"
import script from "./ArchitectesInterieur.vue?vue&type=script&lang=js"
export * from "./ArchitectesInterieur.vue?vue&type=script&lang=js"

import "./ArchitectesInterieur.vue?vue&type=style&index=0&id=387b7e46&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387b7e46"]])

export default __exports__